/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCookingClassTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCookingClass,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Cook Together!",
    "Cooking Class Awaits!",
    "Whip Up Some Delights!",
  ],
  title: "Cooking Class",
  description: "Organize an engaging cooking class.",
  longDescription:
    "Gather your friends for a fun cooking class! Choose a date, decide on recipes to try, and plan the ingredients needed!",
  emoji: "🍳",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Cooking Class",
          emoji: "🍳",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the cooking class?",
          emoji: "📅",
          completeAction: {
            question: "Decide on recipes to prepare?",
            description: "What recipes should we focus on during the class?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What recipes should we choose?",
                emoji: "🥘",
                completeAction: {
                  question: "Decide on ingredients needed?",
                  description:
                    "What ingredients should we gather for the recipes?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What ingredients should we bring?",
                      emoji: "🥦",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Cook Up a Feast!",
    outroDescription:
      "Your cooking class plans are set! Enjoy the culinary adventure!",
  },
};
